import { render, staticRenderFns } from "./addSupply.vue?vue&type=template&id=68634d52&"
import script from "./addSupply.vue?vue&type=script&lang=js&"
export * from "./addSupply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports